import {
  Button,
  Flex,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  OrderedList,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { MdErrorOutline } from "react-icons/md";

import { UploadTask } from "@nens/brostar/openapi-client";

type Props = {
  variant?: string;
  uploadTask: UploadTask;
};

const BroErrorModal: React.FC<Props> = ({ uploadTask, variant }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { broErrors, uuid } = uploadTask;
  // eslint-disable-next-line no-eval
  const broErrorArray: false | string[] = broErrors && eval(broErrors);

  if (!broErrorArray || !broErrorArray.length) return null;

  return (
    <Flex alignItems="center">
      <Button p={0} onClick={onOpen} variant={variant || "outlinePrimarySmall"}>
        <MdErrorOutline />
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Bro errors:</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <OrderedList>
              {broErrorArray.reverse().map((error) => (
                <ListItem key={error + uuid}>{error.replace(/'/g, " ")}</ListItem>
              ))}
            </OrderedList>
          </ModalBody>

          {/* FUTURE */}
          {/* <ModalFooter>
            <Button variant="outlineGrey" mr={3} onClick={onClose}>
              Annuleer
            </Button>
            <Link
              onClick={onClose}
              to={`/${broDomain?.toLowerCase()}/${mapRegistrationType(
                registrationType
              )}uploadTask/${uuid}`}
            >
              <Button variant="primary">Pas aan</Button>
            </Link>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export { BroErrorModal };
